var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64807 2.26168C5.68191 0.784006 6.69883 0.045168 7.86021 0.0025633C7.95337 -0.000854432 8.04663 -0.000854432 8.13979 0.0025633C9.30117 0.045168 10.3181 0.784006 12.3519 2.26168C14.3858 3.73936 15.4027 4.47819 15.8021 5.56956C15.8341 5.65711 15.863 5.7458 15.8885 5.83546C16.2069 6.95316 15.8184 8.14862 15.0416 10.5395L13.729 14.5791C13.5205 15.221 12.9224 15.6556 12.2475 15.6556C11.3871 15.6556 10.6896 14.9581 10.6896 14.0977V12.0013C10.6896 11.194 10.0352 10.5396 9.22793 10.5396H6.77207C5.96479 10.5396 5.31036 11.194 5.31036 12.0013V14.0977C5.31036 14.9581 4.6129 15.6556 3.75254 15.6556C3.07765 15.6556 2.47951 15.221 2.27096 14.5791L0.958422 10.5396C0.181563 8.14862 -0.206867 6.95316 0.111497 5.83546C0.137036 5.7458 0.165855 5.65711 0.197895 5.56956C0.597298 4.47819 1.61422 3.73936 3.64807 2.26168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.a2dd3df80fce5fb0720d61440a168176.svg";
export { ForwardRef as ReactComponent };